import {t} from 'i18next';
import {Card} from 'primereact/card';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseBreadCrumb from '../../baseContainers/BaseBreadCrumb';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import CompanyAgreementBanner from '../../components/CompanyAgreementBanner';
import {CustomMessages} from '../../components/CustomMessages';
import DivContainer from '../../components/DivContainer';
import BlockUi from '../../components/waitPanel/BlockUi';
import SettingService from '../../services/SettingService';
import UserRanksService from '../../services/UserRanksService';
import UserRoleService from '../../services/UserRoleService';
import StringUtils from '../../utils/StringUtils';
import ActionButton from '../../components/ActionButton';
import RankDialog from './RankDialog';
import ActionLink from '../../components/ActionLink';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Menu } from 'primereact';

class RankListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new UserRanksService());
        this.service = new UserRanksService();
        this.roleService = new UserRoleService();
        this.state = {
            dialogVisible: false,
            dialogViewMode: undefined,
            lang: props.lang,
            supportedLocales: [],
            selectedList: [],
            locale: props.lang,
            list: [],
            loading: true,
            minRange: 0,
            maxRange: 999999999,
            rankDialogVisibile: false,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            settingParameterTypeOptions: [],
            settingGroupTypeOptions: [],
            element: {
                name: undefined,
                id: undefined,
            },
        };
        this.settingService = new SettingService();
        this.renderLanguages = this.renderLanguages.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
        this.actionTemplate = this.actionTemplate.bind(this);
        this.handleOpenEditDialog = this.handleOpenEditDialog.bind(this);
        this.handleCloseRankDialog = this.handleCloseRankDialog.bind(this);
    }

    updateSearchCriteria(criteria) {
        return {
            name: criteria.name,
            locale: criteria.locale,
            id: criteria.id,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        };
    }
    getCleanSearchCriteria() {
        return {
            name: '',
            locale: sessionStorage.getItem('i18nextLng'),
            id: null,
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,
        };
    }
    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'ranks.listTitle';
    }
    getCriteriaName() {
        return 'ranks-list-sc';
    }
    getContainerListName() {
        return 'ranks-list-container';
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    renderCriteria() {}

    tableHeader() {
        const haveSelectedElements = this.state.selectedList.length === 0;
        return (
            <div className='flex flex-wrap justify-content-end gap-2'>
                {haveSelectedElements ? (
                    <ActionButton
                        label={t('global.add')}
                        handleClick={() => {
                            this.setState({rankDialogVisibile: true, dialogViewMode: 'NEW'}, () => {
                                const minRange = this.getMinRangeFrom();
                                const maxRange = this.getMaxRangeFrom();
                                this.setState({
                                    minRange,
                                    maxRange,
                                });
                            });
                        }}
                    />
                ) : (
                    <ActionButton
                        className={'ml-2'}
                        label={t('global.remove')}
                        reverse
                        handleClick={() => {
                            const selectedIds = this.state.selectedList.filter((el) => !StringUtils.isBlank(el.id)).map((el) => el.id);
                            this.service
                                .delete(selectedIds)
                                .then(() => {
                                    this.showSuccessMessage(t('ranks.removed'));
                                    this.setState(
                                        {
                                            selectedList: [],
                                        },
                                        () => {
                                            this.refreshTable();
                                        }
                                    );
                                })
                                .catch((err) => {
                                    this.showErrorMessage(err.message);
                                });
                        }}
                    />
                )}
            </div>
        );
    }

    prepareColumns() {
        return [
            {
                field: 'name',
                header: t('ranks.name'),
                sortable: true,
            },
            {
                field: 'rangeFrom',
                header: t('ranks.from'),
                sortable: false,
            },
            {
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                className: 'table-column-action',
                float: 'center',
            },
        ];
    }
    actionTemplate(rowData) {
         const menuRef = React.createRef();
    
        const menuItems = [
            {
                label: t('global.edit'),
                icon: 'pi pi-pencil',
                command: (e) => this.handleOpenEditDialog(e, rowData),
            }
        ];
    
        return (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        );
    }

    actionTemplate2(rowData) {
        return (
            <div>
                <ActionLink
                    className='p-link float-right'
                    handleClick={(e) => this.handleOpenEditDialog(e, rowData)}
                    variant='blue'
                    iconName='mdi-eye'
                    iconSide='left'
                    iconSize='mdi-24px'
                    iconColor='blue'
                    name='details'
                />
            </div>
        );
    }
    handleOpenEditDialog(e, rowData) {
        const element = structuredClone(rowData);
       
        this.setState({rankDialogVisibile: true, dialogViewMode: 'EDIT', element: element}, () => {
            const minRange = this.getMinRangeFrom();
            const maxRange = this.getMaxRangeFrom();
            this.setState({
                minRange,
                maxRange,
            });
        });
    }

    showDeleteConfirmation() {
        this.setState({
            dialogVisibile: true,
        });
    }

    hideDeleteConfirmation(callback) {
        this.setState(
            {
                dialogVisibile: false,
            },
            () => {
                if (callback) {
                    callback();
                }
            }
        );
    }

    breadCrumbItems() {
        return [{name: t('ranks.title'), url: '/user-ranks-list'}];
    }
    initializeFromBackend() {
        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState({
                    supportedLocales,
                });
            })

            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });
    }
    changeLanguage(a, b, c) {
        const lang = c.target.value;
        this.setState(
            (a) => ({
                criteria: {
                    ...a.criteria,
                    locale: lang,
                },
            }),
            () => {
                this.getList();
            }
        );
    }

    renderLanguages() {
        return;
    }
    handleCloseRankDialog(e, callback) {
        if (e) {
            e.preventDefault();
        }
        this.setState({rankDialogVisibile: false});
        if (typeof callback === 'function') callback();
    }
    renderHeader() {
        return <React.Fragment>{this.renderLanguages()}</React.Fragment>;
    }
    getMinRangeFrom() {
        let rangesFrom = this.state.list.map((el) => el.rangeFrom);
        if (rangesFrom.length === 0) {
            return 0;
        }
        if (this.state.dialogViewMode === 'NEW') {
            const highestElement = Math.max(...rangesFrom);
            return highestElement + 0.1;
        }
        rangesFrom = rangesFrom.filter((rangeFrom) => rangeFrom < this.state.element.rangeFrom).sort((a, b) => b - a);
        if (rangesFrom.length >= 1) {
            return rangesFrom[0] + 0.1;
        }
        return 0;
    }
    getMaxRangeFrom() {
        let rangesFrom = this.state.list.map((el) => el.rangeFrom);
        if (rangesFrom.length === 0 || this.state.dialogViewMode === 'NEW') {
            return 999999999;
        }
        rangesFrom = rangesFrom.filter((rangeFrom) => rangeFrom > this.state.element.rangeFrom).sort((a, b) => a - b);
        if (rangesFrom.length >= 1) {
            if (rangesFrom[0] <= 0) {
                return 0;
            }
            return rangesFrom[0] - 0.1;
        }
        return 999999999;
    }
    renderView() {
        return (
            <DivContainer colClass=''>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <CompanyAgreementBanner />
                    <BaseBreadCrumb items={this.breadCrumbItems()} />
                    <Card className='list-card'>
                        <DivContainer colClass='row for-ranks-margin'>{this.renderHeader()}</DivContainer>
                        <div>{this.renderDataTable(this.prepareColumns())}</div>
                    </Card>
                </BlockUi>
                {this.state.rankDialogVisibile ? (
                    <RankDialog
                        style={{maxWidth: '500px'}}
                        onHide={this.handleCloseRankDialog}
                        visible={this.state.rankDialogVisibile}
                        supportedLocales={this.state.supportedLocales}
                        locale={this.state.criteria.locale}
                        viewMode={this.state.dialogViewMode}
                        element={this.state.element}
                        minRangeFrom={this.state.minRange}
                        maxRangeFrom={this.state.maxRange}
                        afterSave={(e) =>
                            this.handleCloseRankDialog(e, () => {
                                this.readMessage();
                                this.refreshTable();
                                this.unblockUi();
                            })
                        }
                        handleError={(err) => {
                            this.handleCloseRankDialog(null, () => {
                                this.unblockUi();
                                this.showErrorMessage(err.json.message);
                            });
                        }}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        _isMounted={this._isMounted}
                        showErrorMessage={this.showErrorMessage}
                        showSuccessMessage={this.showSuccessMessage}
                    />
                ) : null}
            </DivContainer>
        );
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

RankListContainer.defaultProps = {
    detailUrl: '/ranks/details',
    newUrl: '/ranks/create',
    backUrl: '',
    lazy: true,
    selectionMode: 'multiple',
};

RankListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
    backUrl: PropTypes.string,
};

export default withRouter(withTranslation()(RankListContainer));
